export const SET_CURRENT_CUSTOMER = 'SET_CURRENT_CUSTOMER';
export const SET_CURRENT_CUSTOMER_DATA = 'SET_CURRENT_CUSTOMER_DATA';
